import fluxHelper from './helper';
import fluxUI from './ui';
import fluxStepper from "./stepper";
import fluxValidation from './validation';

var fluxCart = {};

fluxCart.init = function () {
    fluxCart.removeControls();
    fluxCart.quantityControls();
    fluxCart.moveShippingRow();
};

fluxCart.runOnce = function () {
    fluxCart.orderSummaryToggle( true );
    var header = document.querySelector( '.flux-checkout__sidebar-header' );
    if ( header ) {
        header.addEventListener( 'click', fluxCart.orderSummaryToggle );
    }
}

/**
 * Add cart button.
 */
fluxCart.removeControls = function () {
    var removeControls = document.querySelectorAll( '.flux-checkout__remove-link a.remove' );
    Array.from( removeControls ).forEach( function( control ) {
        control.addEventListener( 'click', async function( e ) {
            e.preventDefault();
            
            var name = e.target.closest( '.cart_item' ).querySelector( '.quantity input[type="number"]' ).getAttribute( 'name' );
            var cart_item_key = name.replace( 'cart[', '' ).replace( '][qty]', '' );

            var data = {
                action: 'flux_update_item_quantity',
                cart_item_key: cart_item_key,
                quantity: 0,
                security: flux_checkout_vars.update_cart_nonce,
            };

            await fluxHelper.ajaxRequest( data, function( result ) {
                if ( result ) {
                    jQuery( 'body' ).trigger( 'update_checkout' );
                }
            } );

            return false;
        });
    });
};

/**
 * Add quantity control.
 */
fluxCart.quantityControls = function () {
    var quantityControls = document.querySelectorAll( '.quantity input[type="number"]' );
    Array.from( quantityControls ).forEach( function( control ) {
        var controlWrapper = control.closest( '.quantity' );

        if ( 0 < jQuery( controlWrapper ).find( '.quantity__button' ).length ) {
            return;
        }

        var buttonMinus = document.createElement( 'button' );
        buttonMinus.setAttribute( 'type', 'button' );
        buttonMinus.classList.add( 'quantity__button' );
        buttonMinus.classList.add( 'quantity__button--minus' );
        buttonMinus.innerHTML = '-';
        controlWrapper.prepend( buttonMinus );
        buttonMinus.addEventListener( 'click', function() {
            control.value = parseInt( control.value ) - 1;
            control.dispatchEvent( new Event( 'change' ) );
        });

        var buttonPlus = document.createElement( 'button' );
        buttonPlus.setAttribute( 'type', 'button' );
        buttonPlus.classList.add( 'quantity__button' );
        buttonPlus.classList.add( 'quantity__button--plus' );
        buttonPlus.innerHTML = '+';
        controlWrapper.appendChild( buttonPlus );
        buttonPlus.addEventListener( 'click', function() {
            control.value = parseInt( control.value ) + 1;
            control.dispatchEvent( new Event( 'change' ) );
        });

        control.addEventListener( 'change', async function( e ) {
            e.preventDefault();
            e.target.setAttribute( 'disabled', 'disabled' );

            var name = e.target.getAttribute( 'name' );
            var cart_item_key = name.replace( 'cart[', '' ).replace( '][qty]', '' );
            var quantity = e.target.value;

            var data = {
                action: 'flux_update_item_quantity',
                cart_item_key: cart_item_key,
                quantity: quantity,
                security: flux_checkout_vars.update_cart_nonce,
            };

            fluxCart.block();

            await fluxHelper.ajaxRequest( data, function ( result ) {
                var response = JSON.parse( result );
                if ( response.success ) {
                    e.target.removeAttribute( 'disabled' );
                    fluxCart.updateCartCount();
                } else {
                    if ( response && response.data && response.data.error ) {
                        fluxValidation.displayGlobalNotice( response.data.error );
                    }
                }

                jQuery( 'body' ).trigger( 'update_checkout' );
                fluxCart.unblock();
            } );

            return false;
        });
    });
};

/**
 * Updates the Cart Count.
 * 
 * Updates the cart count that is shown on the modern theme.
 */
fluxCart.updateCartCount = function() {
    var total = 0;

    jQuery( '.quantity input.qty' ).each( function() {
        total += parseInt( jQuery(this).val(), 10 );
    });

    var cart_count = jQuery( '.order_review_heading__count');
    if ( cart_count.length ) {
        cart_count.html( total );
    }
};

/**
 * Update Total.
 * 
 * Update the total when the cart changes.
 */
fluxCart.update_total = function() {
    var total = jQuery('.order-total td:last-of-type').html();
    jQuery( '.flux-checkout__sidebar-header-total' ).html( total );
};

/**
 * Move Shipping Row.
 * 
 * Move the shipping row to the top of the order table or
 * to address tab on mobile.
 * 
 * @returns void
 */
fluxCart.moveShippingRow = function () {
    var is_modern = document.querySelectorAll( '.flux-checkout--modern' ).length;

    // No need to run this code for classic theme.
    if ( !is_modern ) {
        return;
    }

    const width = jQuery( window ).width();
    const is_mobile = width < 1023;
    const has_sidebar = jQuery( '.flux-checkout--has-sidebar' ).length;

    var $shipping_row = jQuery( 'tr.woocommerce-shipping-totals.shipping:last' );
    const shipping_table = jQuery( '.flux-checkout__shipping-table tr.woocommerce-shipping-totals.shipping' );

    /*
	 * Since we are moving the shipping data to another table,
	 * we need to remove if it exists.
	 */
    if ( shipping_table ) {
        jQuery( '.flux-checkout__shipping-table tr.woocommerce-shipping-totals.shipping' ).remove();
    }

    if ( ! is_mobile && has_sidebar ) {
        //  Shipping method should appear on the sidebar.
        jQuery( '.flux-checkout__content-right .flux-checkout__shipping-table tbody' ).prepend( $shipping_row );
    } else {
        // shipping method should appear on step 2.
        jQuery( '.flux-step--address .flux-checkout__shipping-table tbody' ).prepend( $shipping_row );
    }
};

jQuery( document.body ).on( 'update_checkout', function() {
	jQuery('.flux-checkout__shipping-table').block({
		message: null,
        overlayCSS: {
            background: '#fff',
            opacity: 0.6
        }
	});
} );

jQuery( document.body ).on( 'updated_checkout', function( e, data ) {
    jQuery( '.flux-checkout__shipping-table' ).unblock();
    
    if ( fluxHelper.isModernCheckout() ) {
        fluxCart.addShippingRowToOrderSummary( data );
    }

    if ( data?.fragments?.flux?.empty_cart ) { // jshint ignore:line
        jQuery( '.flux-checkout' ).append( data.fragments.flux.empty_cart );
        
        setTimeout(() => {
            window.location = flux_checkout_vars.shop_page;
        }, 3000);
    }
} );

/**
 * Hide Show Order Summary.
 * 
 * Toggle for the checkout summary on mobile view.
 */
fluxCart.orderSummaryToggle = function( first ) {
    var isModern = document.querySelectorAll( '.flux-checkout--modern' ).length;
    var linkHide = document.querySelector( '.flux-checkout__sidebar-header-link--hide' );
    var linkShow = document.querySelector( '.flux-checkout__sidebar-header-link--show' );
    var sideBar = document.querySelector( '.flux-checkout__order-review' );

    if ( isModern ) {
        var sideBar = document.querySelector( '.flux-checkout__content-right' );
    }

    if ( ! linkHide || ! sideBar ) {
        return;
    }

    var style = window.getComputedStyle( linkHide );
    if ( style.display === 'none' ) {
        linkHide.style.display = 'block';
        linkShow.style.display = 'none';
        if ( first ) {
            sideBar.style.display = 'block';
        } else {
            fluxUI.slideDown( sideBar );
        }
    } else {
        linkHide.style.display = 'none';
        linkShow.style.display = 'block';
        if ( first ) {
            sideBar.style.display = 'none';
        } else {
            fluxUI.slideUp( sideBar );
        }
    }
};

fluxCart.block = function () {
    jQuery( '.woocommerce-checkout-payment, .woocommerce-checkout-review-order-table' ).block( {
        message: null,
        overlayCSS: {
            background: '#fff',
            opacity: 0.6
        }
    } );
};

fluxCart.unblock = function () {
    jQuery( '.woocommerce-checkout-payment, .woocommerce-checkout-review-order-table' ).unblock();
};

/**
 * Add shipping cost row to the order review table for mobile view.
 */
fluxCart.addShippingRowToOrderSummary = function ( data ) {
    // Add row if it doesn't exits.
    if ( !jQuery( '.flux-shop-table-shipping-price' ).length ) {
        jQuery( '.shop_table tfoot .cart-subtotal' ).after( '<tr class="flux-shop-table-shipping-price"></tr>' );
    }

    // Add shipping cost data received from the fragment.
    if ( data?.fragments?.flux?.shipping_row ) { // jshint ignore:line
        jQuery( '.flux-shop-table-shipping-price' ).html( data.fragments.flux.shipping_row );
    }
};

let on_resize;
jQuery( window ).on('resize', function() {
	clearTimeout( on_resize );
    on_resize = setTimeout( fluxCart.moveShippingRow, 250 );
} );

export default fluxCart;